<template>
  <div v-if="info && info.length" style="position: relative; width: 100%; height: 100%;">
    <p style="position: absolute; width: 100%; text-align: center; padding: 0; margin: 20px 0 0 -15px;">Total Update Requests: {{ totalRequests }}</p>
    <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: space-around;">
      <div style="height: 240px; width: 240px; margin-top: 60px; margin-left: 0">
        <canvas id="rolloutchart"></canvas> 
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'

export default { 
  props: {
    info: {
      type: Array,
      default: () => []
      /*[
          {
              "completed": 2
          },
          {
              "accepted": 3
          },
          {
              "failed": 4
          }
      ]*/
    }
  },

  data () {
    return {
      chart: false
    }
  },

  mounted () {
   this.buildChart()
  },

  watch: {
    info() {
      this.$nextTick(() => {
        this.buildChart()
      })
    }
  },

  computed: {
    totalRequests () {
      return Object.values(this.chartData).reduce((total, item) => {
        return total += item
      }, 0)
    },
    // chart data
    chartData () {
      return this.info.reduce((set, item) => {
        let failureReason = Object.keys(item)
        set[failureReason[0]] = item[failureReason[0]]
        return set
      }, {})
    }
  },

  methods: {
    buildChart () {
      const labels = Object.keys(this.chartData)
      let colors = {
        Accepted: '#FFA500',
        Completed: '#18a31b',
        Failure: '#cc0000'
      }
      const data = {
        labels: labels,
        datasets: [
          {
            label: 'Device count',
            data: Object.values(this.chartData),
            backgroundColor: labels.map(i => colors[i]),
            hoverOffset: 4
          }
        ]
      }

      const config = {
        height: '100%',
        responsive: true,
        plugins: {
          legend: {
            display: false,
            position: 'right',
            labels: {
              color: 'rgba(0,0,0,0.6)'
            }
          }
        }
      }

      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(
      document.getElementById('rolloutchart'), {
        type: 'pie', 
        data: data,
        options: config
      })
    }
  }
}
</script>